import {
  Box,
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  HStack,
  Image,
  Input,
  InputGroup,
  InputLeftElement,
  Select,
  Stack,
  Text,
  useToast,
} from "@chakra-ui/react";
import { useFormik } from "formik";
import { useEffect, useRef, useState } from "react";

import { MdEmail, MdMailOutline, MdPhone } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import trainer from "../../img/trainer.svg";
import registrationService from "../../services/registration.service";
import routes from "../routes";
import Footer from "../../components/common/Footer";

const TrainerPreRegistration = () => {
  const [gender, setGender] = useState<any[]>([]);
  const navigate = useNavigate();

  const toast = useToast();
  const courseFormatRef = useRef<HTMLSelectElement>(null);

  useEffect(() => {
    const maingender = [
      {
        id: "1",
        title: "male",
      },
      {
        id: "2",
        title: "female",
      },
    ];
    setGender(maingender);
  }, []);

  const formik = useFormik({
    validate: (values: any) => {
      const errors: any = {};
      const regex: any = new RegExp("[a-z0-9]+@[a-z]+.[a-z]{2,3}");
      if (!values.firstName) {
        errors.firstName = "First Name is required";
      }
      if (!values.lastName) {
        errors.lastName = "Last Name is required";
      }
      if (!values.password) {
        errors.password = "Password is required";
      }
      if (!values.confirmPassword) {
        errors.confirmPassword = "Confirm Password";
      }
      if (values.password !== values.confirmPassword) {
        errors.confirmPassword = "Password do not match";
      }
      if (!values.emailAddress) {
        errors.emailAddress = "Email Address is required";
      }
      if (!regex.test(values.emailAddress)) {
        errors.emailAddress = "Please enter a valid email address";
      }
      if (!values.phoneNumber) {
        errors.phoneNumber = "Phone Number is required";
      }
      if (
        values.phoneNumber.toString().length < 10 ||
        values.phoneNumber.toString().length > 10
      ) {
        errors.phoneNumber = "Please enter valid phone number";
      }
      if (!values.dob) {
        errors.dob = "Date of Birth is required";
      }
      if (new Date().getFullYear() - new Date(values.dob).getFullYear() < 0) {
        errors.dob = "Please select valid date";
      } else if (
        new Date().getFullYear() - new Date(values.dob).getFullYear() <
        15
      ) {
        errors.dob = "Minimum age should be 15years";
      }
      if (!values.gender) {
        errors.gender = "Gender is required";
      }

      return errors;
    },
    initialValues: {
      firstName: "",
      lastName: "",
      emailAddress: "",
      phoneNumber: "",
      dob: "",
      gender: "",
      password: "",
      confirmPassword: "",
    },
    onSubmit: async (values) => {
      // navigate(routes.VerifyEmail)

      const preRegInfo: any = {
        first_name: values.firstName,
        last_name: values.lastName,
        email: values.emailAddress,
        phone: values.phoneNumber.toString(),
        dob: values.dob,
        gender: values.gender,
        password: values.password,
        password_confirmation: values.confirmPassword,
        category: "trainer",
      };

      try {
        const preReg = await registrationService.preRegistration(preRegInfo);
        if (preReg.status == "success") {
          navigate(routes.PendingVerification);
          localStorage.setItem("userMail", preReg.data.email);

          toast({
            title: "Pre Registration Information",
            description: "Registration successful",
            status: "success",
          });
        }
      } catch (error: any) {
        toast({
          title: "Pre Registration",
          description: `${error.response.data.message}`,
          status: "error",
          duration: 2000,
        });
      }
    },
  });

  return (
    <>
      <Box height={"auto"}>
        <Flex
          height="45px"
          bg="#FFFFFF"
          borderBottom="0.3px solid"
          borderColor="gray.200"
          direction="row"
          px={["12px", "14px"]}
          alignItems="center"
          justifyContent="space-between"
        >
          <Flex alignItems="center">
            <Box as="span">
              <Box color="#EC3337" fontWeight="600" fontSize="12px">
                <Link to={routes.LandingPage}>Main Page</Link>
              </Box>
            </Box>
          </Flex>
          <Flex
            alignItems="center"
            height="inherit"
            color="#616161"
            fontSize="12px"
            lineHeight="16px"
            display={{ lg: "flex", md: "flex", sm: "none", base: "none" }}
          >
            <HStack>
              <MdPhone />
              <Text>
                08060844971, 08033543304, 07067777559 [9:00AM - 5:00PM] |
              </Text>
            </HStack>
            <HStack ml={2}>
              <MdEmail />
              <Text>support@naptinportal.com</Text>
            </HStack>
          </Flex>
        </Flex>
        <Flex height="100%" px={["15px", "15px", "0px", "0px"]}>
          <Box
            width={["0%", "0%", "50%", "54%"]}
            display={["none", "none", "block", "block"]}
            height="55rem"
          >
            <Image objectFit="cover" height="100%" width="100%" src={trainer} />
          </Box>
          <Box
            mt="10px"
            width={["100%", "100%", "45%", "45%"]}
            mx="auto"
          >
            <Box mt={6} py={4} width={["100%", "100%", "80%", "80%"]}>
              <Box px={8}>
                <Flex mb="35px">
                  <Text mx="auto" fontSize="32px" fontWeight="700">
                    Register as a Trainer
                  </Text>
                </Flex>
                <Text mb="35px" color="#9E9E9E" fontSize="14px">
                  All fields in{" "}
                  <Text as="span" color="red" fontWeight="600">
                    (*){" "}
                  </Text>
                  are required
                </Text>

                <form onSubmit={formik.handleSubmit}>
                  <Stack
                    mb={["10px", "10px", "25px", "25px"]}
                    direction={["column", "column", "row", "row"]}
                  >
                    <FormControl
                      isInvalid={
                        formik.errors.firstName && formik.touched.firstName
                          ? true
                          : false
                      }
                    >
                      <FormLabel
                        fontWeight="normal"
                        color="brand.3"
                        fontSize={13}
                      >
                        First Name{" "}
                        <Text as="span" color="red">
                          *
                        </Text>
                      </FormLabel>
                      <Input
                        bg="inputText.500"
                        placeholder="Enter first name"
                        value={formik.values.firstName}
                        name="firstName"
                        onChange={formik.handleChange}
                        fontSize={12}
                      />
                      <FormErrorMessage fontSize={12}>
                        {formik.errors.firstName}
                      </FormErrorMessage>
                    </FormControl>
                    <FormControl
                      isInvalid={
                        formik.errors.lastName && formik.touched.lastName
                          ? true
                          : false
                      }
                    >
                      <FormLabel
                        fontWeight="normal"
                        color="brand.3"
                        fontSize={13}
                      >
                        Last Name{" "}
                        <Text as="span" color="red">
                          *
                        </Text>
                      </FormLabel>
                      <Input
                        bg="inputText.500"
                        placeholder="Enter last Name"
                        value={formik.values.lastName}
                        name="lastName"
                        onChange={formik.handleChange}
                        fontSize={12}
                      />
                      <FormErrorMessage fontSize={12}>
                        {formik.errors.lastName}
                      </FormErrorMessage>
                    </FormControl>
                  </Stack>

                  <FormControl
                    mb={["10px", "10px", "25px", "25px"]}
                    isInvalid={
                      formik.errors.emailAddress && formik.touched.emailAddress
                        ? true
                        : false
                    }
                  >
                    <FormLabel color="brand.subtitle" fontSize={12}>
                      Email address{" "}
                      <Text as="span" color="red">
                        *
                      </Text>
                    </FormLabel>
                    <InputGroup>
                      <InputLeftElement
                        color="brand.subtitle"
                        pointerEvents="none"
                        children={<MdMailOutline />}
                      />
                      <Input
                        type="email"
                        id="emailAddress"
                        name="emailAddress"
                        placeholder="alex@gmail.com"
                        onChange={formik.handleChange}
                        fontSize={13}
                      />
                    </InputGroup>
                    <FormErrorMessage fontSize={12}>
                      {formik.errors.emailAddress}{" "}
                    </FormErrorMessage>
                  </FormControl>

                  <FormControl
                    mb={["10px", "10px", "25px", "25px"]}
                    mt={6}
                    isInvalid={
                      formik.errors.phoneNumber && formik.touched.phoneNumber
                        ? true
                        : false
                    }
                  >
                    <FormLabel
                      fontWeight="normal"
                      color="brand.3"
                      fontSize={13}
                    >
                      Phone number{" "}
                      <Text as="span" color="red">
                        *
                      </Text>
                    </FormLabel>
                    <Input
                      type="number"
                      id="phoneNumber"
                      name="phoneNumber"
                      placeholder="080*******"
                      onChange={formik.handleChange}
                      fontSize={13}
                    />

                    <FormErrorMessage fontSize={12}>
                      {formik.errors.phoneNumber}
                    </FormErrorMessage>
                  </FormControl>

                  <Stack
                    mb={["10px", "10px", "25px", "25px"]}
                    direction={["column", "column", "row", "row"]}
                    spacing={"10px"}
                  >
                    <FormControl
                      isInvalid={
                        formik.errors.dob && formik.touched.dob ? true : false
                      }
                    >
                      <FormLabel
                        fontWeight="normal"
                        color="brand.3"
                        fontSize={13}
                      >
                        Date of Birth{" "}
                        <Text as="span" color="red">
                          *
                        </Text>
                      </FormLabel>
                      <InputGroup>
                        <Input
                          placeholder="Select Date of Birth"
                          type="date"
                          bg="inputText.500"
                          name="dob"
                          value={formik.values.dob}
                          onChange={formik.handleChange}
                          fontSize={12}
                        />
                        {/* <InputRightElement pointerEvents="none" children={<VscCalendar fontSize={20} color="#7883A7" />} /> */}
                      </InputGroup>
                      <FormErrorMessage fontSize={12}>
                        {formik.errors.dob}
                      </FormErrorMessage>
                    </FormControl>

                    <FormControl
                      isInvalid={
                        formik.errors.gender && formik.touched.gender
                          ? true
                          : false
                      }
                    >
                      <FormLabel
                        fontWeight="normal"
                        color="brand.3"
                        fontSize={13}
                      >
                        Gender{" "}
                        <Text as="span" color="red">
                          *
                        </Text>
                      </FormLabel>
                      <Select
                        ref={courseFormatRef}
                        variant="outline"
                        bg="inputText.500"
                        size="sm"
                        fontSize={12}
                        placeholder="Select gender"
                        value={formik.values.gender}
                        name="gender"
                        onChange={(e) => {
                          formik.handleChange(e);
                        }}
                        color="brand.subtitle"
                      >
                        {gender.map((each) => (
                          <option key={each.id} value={each.title}>
                            {" "}
                            {each.title}{" "}
                          </option>
                        ))}
                      </Select>
                      <FormErrorMessage fontSize={12}>
                        {formik.errors.gender}
                      </FormErrorMessage>
                    </FormControl>
                  </Stack>

                  <Stack
                    mb={["10px", "10px", "25px", "25px"]}
                    direction={["column", "column", "row", "row"]}
                    spacing={"10px"}
                  >
                    <FormControl
                      isInvalid={
                        formik.errors.password && formik.touched.password
                          ? true
                          : false
                      }
                    >
                      <FormLabel
                        fontWeight="normal"
                        color="brand.3"
                        fontSize={13}
                      >
                        Password{" "}
                        <Text as="span" color="red">
                          *
                        </Text>
                      </FormLabel>
                      <InputGroup>
                        <Input
                          placeholder="Enter password"
                          type="password"
                          bg="inputText.500"
                          name="password"
                          value={formik.values.password}
                          onChange={formik.handleChange}
                          fontSize={12}
                        />
                        {/* <InputRightElement pointerEvents="none" children={<VscCalendar fontSize={20} color="#7883A7" />} /> */}
                      </InputGroup>
                    </FormControl>

                    <FormControl
                      isInvalid={
                        formik.errors.confirmPassword &&
                        formik.touched.confirmPassword
                          ? true
                          : false
                      }
                    >
                      <FormLabel
                        fontWeight="normal"
                        color="brand.3"
                        fontSize={13}
                      >
                        Confirm Password{" "}
                        <Text as="span" color="red">
                          *
                        </Text>
                      </FormLabel>
                      <InputGroup>
                        <Input
                          placeholder="Confirm password"
                          type="password"
                          bg="inputText.500"
                          name="confirmPassword"
                          value={formik.values.confirmPassword}
                          onChange={formik.handleChange}
                          fontSize={12}
                        />
                        {/* <InputRightElement pointerEvents="none" children={<VscCalendar fontSize={20} color="#7883A7" />} /> */}
                      </InputGroup>
                    </FormControl>
                  </Stack>

                  <Stack spacing="12px">
                    <Button
                      cursor="pointer"
                      w="100%"
                      bg="red"
                      color="white"
                      type="submit"
                      isLoading={formik.isSubmitting}
                      fontSize={14}
                    >
                      CREATE
                    </Button>
                  </Stack>
                  <Flex justifyContent="center" mt={6}>
                    <Text fontSize="14px" color="#EC3337">
                      Have an account? <Link to={routes.Login}>Login here</Link>
                    </Text>
                  </Flex>
                </form>
              </Box>
            </Box>
          </Box>
        </Flex>
        <Footer />
      </Box>
    </>
  );
};

export default TrainerPreRegistration;
